import { useRef } from 'react';
import { Box } from '@cad-arc';
import { FederatedSearchEventPanelDexActivityList } from '../../../federated-search/federated-search-event-panel-dex-activity-list';
import { TabBody } from '../../../panels/entity-panels/tabs/tab-body';
import { useWorkspacePanel } from '../../../panels/hooks/use-workspace-panel';
import { EventPanelTab } from '../components/event-panel-tab';

export function DexNextActivityTab() {
    const exportButtonContainerRef = useRef<HTMLElement>(null);
    const { linkedEntityId } = useWorkspacePanel();
    return (
        <EventPanelTab
            titleTrailingNode={<Box ref={exportButtonContainerRef}></Box>}
            title="Universal Search Results"
        >
            <TabBody constrainToParentHeight={true}>
                <FederatedSearchEventPanelDexActivityList
                    eventId={linkedEntityId}
                    exportButtonContainerRef={exportButtonContainerRef}
                />
            </TabBody>
        </EventPanelTab>
    );
}
